import MenuCard from './Components/MenuCard.js';
import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import WallAppBar from './Components/AppBar/WallAppBar.js';
import WordListDialog from './Components/WordListDialog.js';
import Typography from '@mui/material/Typography';
import { BrowserRouter as Router, Switch, Route, Routes, Link, Outlet} from "react-router-dom";
import Config from './Config.json';
import Skeleton from '@mui/material/Skeleton';

import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

var loadingData = [
    {
      "title":"School",
      "picture": "iVBORw0KGgoAAAANSUhEUgAAABcAAAABCAIAAAC6x6JxAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAWSURBVBhXYwCC////o5EQgJ+NIBkYAEUrF+lZr6HIAAAAAElFTkSuQmCC",
      "description": "Learn to express feelings and needs",
      "include": true,
      "wordCount":69,
      "wordList": [
        {
          "id":0,
          "word": "louer",
          "definition":"to rent",
          "familiarity": 69,
          "include":true,
        },
      ]
    }
  ]

const breadcrumbs = [
    <Link underline="hover" to="/" key="1" color="white" href="/">
      Vocab App
    </Link>,
    <Typography key="3" color="white">
      Curriculum
    </Typography>,
    <Typography key="3" color="white">
      Word Category
    </Typography>
  ];

function WordsPage() {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [wordsPageData, setWordsPageData] = useState(loadingData);
  const [openDiag, setOpenDiag] = useState(false);
  //index of menuCard chosen by user
  const [chosenIndex, setChosenIndex] = useState(0);
  const [currentWordList, setCurrentWordList] = useState(wordsPageData[0]["wordList"]);
  const [dialogTitle, setDialogTitle] = useState("");

  const [checkBoxState, setCheckBoxState]  = useState(wordsPageData.map(() => null));

  const [enableSave, setEnableSave] = useState(false);

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackError, setSnackError] = useState(null);

  React.useEffect(() => {
      // console.log("rheeeeeeeeeeeeee");

      axios.get(Config.urlStub + "/wordData", {"withCredentials":true}).then((response) => {
        // console.log('rhee');
        //lessonData = response.data;
        // console.log("lessonData is", response.data);
        // wordsPageData.map((value, index) => {
        //   console.log("include is", value.include);
        // })
        setDataLoaded(true);
        setWordsPageData(response.data);
        // console.log("Worddatainclude is",response.data.map((wordData) => wordData.include));
        setCheckBoxState(response.data.map((wordData) => wordData.include));
      }).catch((error) => {
        // console.log(error);
      });

      // console.log("rhee updating wordsPageData", wordsPageData);
    }, []);

  function toggleCheckboxState(index) {
    setEnableSave(true);
    // console.log("toggle checkbox triggered", index)
    // console.log("old state", checkBoxState)
    const newCheckBoxState = checkBoxState.map((c, i) => {
      if (i === index) {
        //update value of chosen index
        return !checkBoxState[i];
      } else {
        //do nothing
        return c;
      }
    });
    // console.log("new state", newCheckBoxState)
    setCheckBoxState(newCheckBoxState);
  }

  function handleOpen(index) {
    setOpenDiag(true);
    setChosenIndex(index);
    setCurrentWordList(wordsPageData[index]["wordList"]);
    setDialogTitle(wordsPageData[index]["title"]);
  }

  function handleClose() {
    setOpenDiag(false);
  }

  function saveFromDialog() {
    var reqObj = {};
    reqObj["title"] = wordsPageData[chosenIndex]["title"]
    reqObj["selectionModel"] = wordsPageData[chosenIndex]["selectionModel"];
    
    // console.log(reqObj);

  axios.post(Config.urlStub + "/saveFromDialog", reqObj, {"withCredentials":true}).then((response) => {
        setSnackError(null);
        setEnableSave(false);
        // //TODO: add snackbar for displaying success message
        setSnackOpen(true);
        setOpenDiag(false);
      }).catch((response) => {
        // console.log(response.response.data)
        setSnackError(response.response.data)
        setSnackOpen(true);
        //TODO: add snackbar for displaying fail message
        console.log("save failed")
      });
  }

  function handleSnackClose() {
    setSnackOpen(false);
  }

  function saveSettings() {

    var reqObj = {};

    for (var i = 0; i < wordsPageData.length; i++) {
      reqObj[wordsPageData[i]["title"]] = checkBoxState[i];
    }

    axios.post(Config.urlStub + "/saveWordBanks", reqObj, {"withCredentials":true}).then((response) => {
        setEnableSave(false);
        //TODO: add snackbar for displaying success message
        setSnackOpen(true);
      }).catch((response) => {
        //TODO: add snackbar for displaying fail message
        console.log("save failed")
      });
  }

  //function for handling state of individual words (checked or not)
  function setSelectionModel(ids) {
    //console.log(wordsPageData[0]["selectionModel"]);
    // console.log("setSelectionModel called", ids);
    const newWordsPageData = wordsPageData.map((c, i) => {
      if (i === chosenIndex) {
        return {
          ...c,
          "selectionModel": ids
        };
      } else {
        return c;
      }
    });
    setWordsPageData(newWordsPageData);
  }

  return (
    <div className="App-header">
      
    {/* <Box sx={{ flexGrow:1 }} className="App-header"> */}
      {/* <TopAppBar breadcrumbs={breadcrumbs}/> */}
      <WallAppBar /> 

      <WordListDialog
        sm={wordsPageData[chosenIndex]["selectionModel"]}
        setSelectionModel={setSelectionModel} 
        saveFromDialog={saveFromDialog} 
        handleClose={handleClose}
        open={openDiag} 
        dialogTitle={dialogTitle} 
        currentWordList={currentWordList} 
      />

<Grid container justifyContent="center" alignItems="center"
 sx={{mb:1, marginTop:"70px", maxWidth:"75%"}} spacing={2} >
        {!dataLoaded && 
          [0,1,2,3,4,5,6,7,8].map((value, index) => {
            return (
            <Grid item>
              <Skeleton width={200} height={350}/>
            </Grid>
            )
          })  
        }
        {dataLoaded && wordsPageData.map((value, index) => {
          return (
            <Grid item>
              <MenuCard imgbase64={value.picture} handleOpen={handleOpen} title={value.title} include={checkBoxState[index]} index={index}
                desc={value.description}
                wordData={value.wordList}
                wordCount={value.wordList.length}
                // updateCheckbox={toggleCheckboxState} 
                percentSelected={value.percentSelected === undefined ? 0 : value.percentSelected}
                sx={{}}
              />
              </Grid>
          )
        })}
      </Grid>

        <Snackbar open={snackOpen} 
        autoHideDuration={1000} 
        onClose={handleSnackClose} anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}>
          <Alert severity={snackError ? "error" : "success"}>
          {snackError ? "Error: " + snackError : "Save Success!"}
          </Alert> 
        </Snackbar>

        {/* <Fab variant="extended" disabled={!enableSave} onClick={() => saveSettings()}
          style={{margin: 0, top: 'auto', right: '5%', bottom: '5%', left: 'auto', position: 'fixed'}}>
          <SaveIcon sx={{ mr: 1 }} />
          Save Settings
        </Fab> */}

        </div>
  );
}

export default WordsPage